import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"13\" height=\"4.5\" x=\"3.5\" y=\"4\" rx=\"1.2\"></rect><rect width=\"7\" height=\"4.5\" x=\"7\" y=\"11.5\" rx=\"1.2\"></rect><rect width=\"7\" height=\"4.5\" x=\"3.5\" y=\"19\" rx=\"1.2\"></rect><circle cx=\"20.5\" cy=\"20\" r=\"6\"></circle><path d=\"M20.5 17v3l2 1.5\"></path>", 5)
  ]))]))
}
export default { render: render }